@if (localForm) {
  @if (isManagedByOrganisation) {
    <p class="alert alert-info mx-2">Note: Some details are managed by your organisation.</p>
  }
  <form
    [formGroup]="localForm"
    (ngSubmit)="saveDocPreferences()"
  >
    <div class="container">
      <formly-form
        [model]="localModel"
        [form]="localForm"
        [fields]="localConfig"
      />
      @if (showSave()) {
        <div class="d-flex justify-content-end my-3">
          <button
            type="submit"
            class="btn btn-colour-blue-600"
            data-testid="saveDocumentPreferencesBtn"
          >
            Save document preferences
          </button>
        </div>
      }
    </div>
  </form>
}
